import networkTS from '@/misc/apis/networkTS'

export default {
  triggerDebitUntilSync(accountId: string) {
    return networkTS.accountingServiceTriggerDebitUntilSync(accountId, { timeout: 300000 }).then(response => {
        return response.data
      })
  },
  TriggerRentAdjustmentSync(accountId: string) {
    return networkTS.accountingServiceTriggerRentAdjustmentSync(accountId, { timeout: 300000 }).then(response => {
        return response.data
      })
  },
  triggerDocumentSync(accountId: string) {
    return networkTS.accountingServiceTriggerDocumentSync(accountId, { timeout: 300000 }).then(response => {
        return response.data
      })
  }
}
